import { buildCategoryTree } from '../../utils/functions/categories_functions';
import * as CategoriesActions from './categories_actions';

const reducer = (
  state = {
    minimalCategoriesList: [],
    minimalCategoriesTree: [],
    lastFetchedMinimalCategories: 0,
  },
  action: any,
) => {
  switch (action.type) {
    case CategoriesActions.GET_CATEGORIES_MINIMALIST: {
      return { ...state };
    }
    case CategoriesActions.GET_CATEGORIES_MINIMALIST_SUCCESS: {
      // build the categories tree using parent_category_id
      return {
        ...state,
        minimalCategoriesList: action.payload?.categories,
        minimalCategoriesTree: buildCategoryTree(action.payload?.categories),
        lastFetchedMinimalCategories: new Date().getTime(),
      };
    }

    case CategoriesActions.SET_LAST_FETCHED_CATEGORIES_MINIMALIST: {
      return {
        ...state,
        lastFetchedMinimalCategories: action.timestamp,
      };
    }

    case CategoriesActions.LOGOUT: {
      return {};
    }

    default:
      return state;
  }
};

export default reducer;
